import { useEffect, useRef, useState } from "react";
import logo from "../../../../images/Icon/20211.png";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { fetchData } from "../../../../Action/NewAction";

function CourseInvoiceView() {
    const { id } = useParams();
    const invoiceRef = useRef(null);
    const [invoice, setInvoice] = useState(null);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US"); // Adjust this locale to match your desired format
    };

    useEffect(() => {
        const getInvoice = async () => {
            const response = await fetchData(
                `/api/Course/GetPremiumCourseInvoicesById?premiumCourseSubscriptionId=${id}`
            );
            if (response?.data?.success) {
                setInvoice(response?.data?.payload);
            }
        };
        getInvoice();
    }, [id]);

    // ✅ Fast download using print-to-PDF (no jsPDF, no canvas)
    const handleDownloadPdf = () => {
        if (!invoiceRef.current) return;

        const content = invoiceRef.current.innerHTML;
        const newWindow = window.open("", "", "height=600,width=800");

        newWindow.document.write(`
      <html>
        <head>
          <title>Course Invoice</title>
          <style>
            body { font-family: "Poppins", sans-serif; padding: 20px; color: #333; }
            h2, h3, h4, p { margin: 0; }
            .invoice-container { max-width: 800px; margin: auto; }
          </style>
        </head>
        <body>
          <div class="invoice-container">${content}</div>
        </body>
      </html>
    `);

        newWindow.document.close();
        newWindow.onload = () => {
            newWindow.focus();
            newWindow.print();
            setTimeout(() => newWindow.close(), 100);
        };
    };

    if (!invoice) return null;

    return (
        <div className="invoice_view_page_group">
            <div className="card">
                <div className="card-body">
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "15px" }}>
                        <Button variant="contained" color="primary" onClick={handleDownloadPdf}>
                            Download
                        </Button>
                    </div>

                    <section
                        ref={invoiceRef}
                        style={{
                            maxWidth: "800px",
                            margin: "0 auto",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "14px",
                            color: "#333",
                            padding: "25px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            lineHeight: "1.6",
                            background: "#fff",
                        }}
                    >
                        {/* Header */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <img src={logo} alt="Logo" style={{ height: "55px" }} />
                            <h2 style={{ margin: 0 }}>Invoice</h2>
                        </div>

                        {/* Invoice Info */}
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                            <div style={{ maxWidth: "50%" }}>
                                <h4 style={{ margin: "5px 0", textTransform: "uppercase" }}>
                                    {invoice.courseTitle}
                                </h4>
                                <p style={{ margin: "3px 0" }}>
                                    {invoice.address}, {invoice.city}, {invoice.state}, {invoice.zipCode}
                                </p>
                            </div>
                            <div style={{ textAlign: "right" }}>
                                <p style={{ margin: "3px 0" }}>
                                    <b>Invoice Number:</b> {invoice.invoiceNo || "000000"}
                                </p>
                                <p style={{ margin: "3px 0" }}>
                                    <b>PO Number:</b> {invoice.ponumber}
                                </p>
                                <p style={{ margin: "3px 0" }}>
                                    <b>Invoice Date:</b> {invoice.createdOn ? formatDate(invoice.createdOn) : "--/--/----"}
                                </p>
                                <p style={{ margin: "3px 0" }}>
                                    <b>Due Date:</b> {invoice.dueDate ? formatDate(invoice.dueDate) : "--/--/----"}
                                </p>
                                {(invoice.status !== "succeeded" && invoice.status !== "cancelled") && (
                                    <a
                                        href={`${window.location.origin}/ceu-courses/coursePurchase/${invoice.courseId}?districtId=${invoice.schoolDistrictId}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            display: "inline-block",
                                            background: "linear-gradient(90deg, #1ebec8 -7.19%, #86c65a 105.94%)",
                                            color: "#fff",
                                            padding: "6px 12px",
                                            borderRadius: "4px",
                                            textDecoration: "none",
                                            fontWeight: "500",
                                            marginTop: "8px",
                                        }}
                                    >
                                        Pay Now
                                    </a>
                                )}
                            </div>
                        </div>

                        {/* Billing */}
                        <div style={{ marginTop: "25px" }}>
                            <h4 style={{ marginBottom: "8px", fontSize: "15px" }}>Billed To</h4>
                            <p style={{ margin: "2px 0" }}>{invoice.fullName}</p>
                            <p style={{ margin: "2px 0" }}>{invoice.email}</p>
                            <p style={{ margin: "2px 0" }}>{invoice.districtName}</p>
                        </div>

                        {/* Course & Amount */}
                        <div
                            style={{
                                marginTop: "25px",
                                borderTop: "1px solid #ddd",
                                paddingTop: "15px",
                            }}
                        >
                            <p style={{ margin: "3px 0" }}>
                                <b>Course Title:</b> {invoice.courseTitle}
                            </p>
                            <p style={{ margin: "3px 0" }}>
                                <b>Instructor:</b> {invoice.instrctorName}
                            </p>
                            <p style={{ margin: "3px 0" }}>
                                <b>Course Type:</b> {invoice.premiumCourseType}
                            </p>
                            <h3 style={{ marginTop: "15px", textAlign: "right" }}>
                                Total: ${invoice.totalAmount.toFixed(2)}
                            </h3>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default CourseInvoiceView;
